import { CLEAR_SITE_DATA } from '../application';
import { REQUEST_USERS, RECEIVE_USERS, RECEIVE_LIMITED_USERS, RECEIVE_USER } from './actions';

const initialState = {
  users: {},
  limitedUsers: [],
  photos: {},
  loadingUsers: true,
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_USERS: {
      return { ...state, loadingUsers: true };
    }
    case RECEIVE_USERS: {
      const { users } = action;

      return {
        ...state,
        users,
        loadingUsers: false,
      };
    }
    case RECEIVE_LIMITED_USERS: {
      return { ...state, limitedUsers: action.users };
    }
    case RECEIVE_USER: {
      const { oid, user } = action;
      return {
        ...state,
        users: {
          ...state.users,
          [oid]: user,
        },
      };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        users: {},
        limitedUsers: [],
        photos: {},
        loadingUsers: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
